
<template>
  <div class="contact-info-wrapper">
    <v-list
      class="pt-0"
      two-line
    >
      <div class="fixed-header ml-2 mt-3 ">
        <v-row class="px-5 ">
          <v-col
            cols="10"
          >
            <h2>Edit Contact Fields</h2>
          </v-col>
          <v-col
            cols="2"
            class="d-flex justify-end pr-0"
          >
            <v-btn
              class="text-right"
              icon
              @click.stop="$store.commit('ui/drawer.right.toggle')"
            >
              <v-icon
                medium
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="px-5 ">
          <v-col
            cols="12"
            class="subtitle-2 pt-0 font-weight-regular text--black"
            style="opacity:0.6"
          >
            If you rearrange the order of contact fields, the new display order is applied to all the contacts.
          </v-col>
        </v-row>
        <v-row class="px-5 ">
          <v-col
            class="mb-2"
            cols="11"
          >
            <v-btn
              outlined
              :loading="loading"
              @click.stop="save_fields"
            >
              SAVE
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-row>
        <v-col class="px-10">
            <v-switch
              color="#03B6FC"
              v-model="workflowDisable"
              label="Do not trigger Journey Campaigns"
            >
              <template v-slot:append>
                <v-tooltip
                  bottom
                  color="rgba(0, 0, 0, 0.9)"
                  max-width="350"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <p class="caption text-justify">
                    This option applies to the condition when any contact field is being edited and 
                    there is a journey active with a trigger for "Contact Field Update.
                  </p>
                  <p class="caption text-justify">
                    If checked, then the contacts that are edited will not enter the journeys where 
                    the trigger is defined as "Contact Field Update". If unchecked, then those 
                    contacts which are edited will enter the journeys as normal.
                  </p>
                  <p class="caption text-justify">
                    <span class="font-weight-bold">NOTE:</span> This option does not apply to any 
                    other journey trigger. Contacts added/edited to the lists will enter those 
                    journeys depending on the journey triggers as they are defined"
                  </p>
                </v-tooltip>
              </template>
            </v-switch>
        </v-col>
      </v-row>

      <v-tabs

        color="#03B6FC"
        height="30px"
        class="ml-2 info-drawer"
      >
        <v-tab>
          <span @click="refreshSelectedFields('selected_default_fields', 500)"
            class="ml-1 body-2 font-weight-regular"
          >
            Default fields ({{ selected_default_fields.length + unselected_default_fields.length }})
          </span>
        </v-tab>
        <v-tab>
          <span @click="refreshSelectedFields('selected_custom_fields', 500)"
            class="body-2 font-weight-regular"
          >
            Custom fields ({{ selected_custom_fields.length + unselected_custom_fields.length }})
          </span>
        </v-tab>
        <v-tab-item>
          <template v-if="loading == true">
            <v-overlay
              :value="loading"
              opacity="0.2"
            >
              <v-progress-circular
                indeterminate
                size="64"
              />
            </v-overlay>
          </template>
          <v-divider class="mb-2" />
          <v-text-field
            v-model="searchString"
            outlined
            class="mt-4 px-5"
            label="Search"
            @keyup="refreshSelectedFields('selected_default_fields')"
            prepend-inner-icon="search"
          />
          <div class="pt-0">
          <v-list
            subheader
            two-line
            flat
          >
            <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
              <span class="white">  Selected ({{ filterItems(selected_default_fields,false).length }})</span>
            </div>
            <v-list-item-group

              class="px-3 list-frame mt-3"
            >
            <v-form
                class="grid selected_default_fields_grid"
                ref="formDefault"
              >
              <v-list-item
                v-for="selected_default_field in filterItems(selected_default_fields,false)"
                :key="selected_default_field[0]"
                class="pa-0 single-list-item item"
                :ripple="false"
                :data-id="selected_default_field[0]" 
              >
              <template v-slot:default="{ }">
                <v-list-item-action
                  class="mr-2 mt-n2"
                  @click="update_fields(selected_default_field,false,true)"
                >
                  <v-icon color="#03B6FC">
                    mdi-checkbox-marked
                  </v-icon>
                </v-list-item-action>

                <v-list-item-content class="pa-1 justify-center">
                  <v-select
                    v-if="typeOfDefaultFields[selected_default_field[0]] === 'boolean'"
                    v-model="selected_default_field[1]"
                    item-color="#AAA6A6"
                    outlined
                    :items="items"
                    item-text="text"
                    item-value="value"
                    :menu-props="{offsetY: true }"
                    :label="selected_default_field[0]"
                    @change="updateFieldsValue(selected_default_field,true)"
                    hide-details
                  />
                  <v-textarea
                    v-else-if="typeOfDefaultFields[selected_default_field[0]] === 'text'"
                    v-model="selected_default_field[1]"
                    :label="selected_default_field[0]"
                    outlined
                    @change="updateFieldsValue(selected_default_field,true)"
                    hide-details
                  />
                  <div v-else-if="typeOfCustomFields[selected_default_field[0]] === 'datetime'">
                    <fieldset
                      class="mb-6"
                      style="border:1px solid lightgrey;border-radius:3px"
                    >
                      <legend
                        v-if="selected_default_field[1]"
                        class="caption font-weight-regular grey--text mb-n2 ml-2 text--darken-2"
                      >
                        {{ selected_default_field[0] }}
                      </legend>
                      <datetime
                        v-model="selected_default_field[1]"
                        class="theme-blue datetime-field"
                        format="y-MM-dd HH:mm:ss ZZZ"
                        :placeholder="selected_default_field[0]"
                        type="datetime"
                        :input-id="'startDate' + selected_default_field[0]"
                        :zone="timezone(selected_default_field[1])"
                        :value-zone="timezone(selected_default_field[1])"
                      >
                        <template slot="button-cancel">
                          Cancel
                        </template>
                        <template slot="button-confirm">
                          <span @click="updateFieldsValue(selected_default_field,true)"> Confirm</span>
                        </template>
                      </datetime>
                    </fieldset>
                  </div>
                  <v-text-field
                    v-else
                    v-model="selected_default_field[1]"
                    :label="selected_default_field[0]"
                    outlined
                    @input="updateFieldsValue(selected_default_field,true)"
                    hide-details
                  />
                </v-list-item-content>
                <span v-if="dragEnabled" class="ml-2 mt-n5 handle" style="cursor:grab">
                  <v-icon class="mr-n2 ml-n2" color="grey">mdi-dots-vertical</v-icon>
                  <v-icon class="ml-n2" color="grey">mdi-dots-vertical</v-icon>
                </span>
                </template>
              </v-list-item>
            </v-form>
            </v-list-item-group>
          </v-list>
          <v-list
            subheader
            two-line
            flat
          >
            <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
              <span class="white"> Unselected ({{ filterItems(unselected_default_fields,false).length }})</span>
            </div>
            <v-list-item-group class="px-4 list-frame mt-3">
              <v-list-item
                v-for="unselected_default_field in filterItems(unselected_default_fields,false)"
                :key="unselected_default_field[0]"
                class="pa-0"
                :ripple="false"
              >
              <template v-slot:default="{ }">
                <v-list-item-action
                  class="mr-2 mt-0"
                  @click="update_fields(unselected_default_field,true,true)"
                >
                  <v-icon color="grey">
                    mdi-checkbox-blank-outline
                  </v-icon>
                </v-list-item-action>

                <v-list-item-content class="pa-1 justify-center">
                  <v-select
                    v-if="typeOfDefaultFields[unselected_default_field[0]] === 'boolean'"
                    v-model="unselected_default_field[1]"
                    item-color="#AAA6A6"
                    outlined
                    :items="items"
                    item-text="text"
                    item-value="value"
                    :menu-props="{offsetY: true }"
                    :label="unselected_default_field[0]"
                    @change="updateFieldsValue(unselected_default_field,true)"
                  />
                  <v-textarea
                    v-else-if="typeOfDefaultFields[unselected_default_field[0]] === 'text'"
                    v-model="unselected_default_field[1]"
                    :label="unselected_default_field[0]"
                    outlined
                    @change="updateFieldsValue(unselected_default_field,true)"
                  />
                  <div v-else-if="typeOfCustomFields[unselected_default_field[0]] === 'datetime'">
                    <fieldset
                      class="mb-6"
                      style="border:1px solid lightgrey;border-radius:3px"
                    >
                      <legend
                        v-if="unselected_default_field[1]"
                        class="caption font-weight-regular grey--text mb-n2 ml-2 text--darken-2"
                      >
                        {{ unselected_default_field[0] }}
                      </legend>
                      <datetime
                        v-model="unselected_default_field[1]"
                        class="theme-blue datetime-field"
                        format="y-MM-dd TT ZZZ"
                        :placeholder="unselected_default_field[0]"
                        type="datetime"
                        :input-id="'startDate'+unselected_default_field[0]"
                        :zone="timezone(unselected_default_field[1])"
                        :value-zone="timezone(unselected_default_field[1])"
                      >
                        <template slot="button-cancel">
                          Cancel
                        </template>
                        <template slot="button-confirm">
                          <span @click="updateFieldsValue(unselected_default_field,true)"> Confirm</span>
                        </template>
                      </datetime>
                    </fieldset>
                  </div>
                  <v-text-field
                    v-else
                    v-model="unselected_default_field[1]"
                    :label="unselected_default_field[0]"
                    outlined
                    @input="updateFieldsValue(unselected_default_field,true)"
                  />
                </v-list-item-content>
              </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
           </div>
        </v-tab-item>
        <v-tab-item>
          <v-divider class="mb-2" />
          <v-text-field
            v-model="searchStringCustom"
            outlined
            class="mt-4 px-9"
            label="Search"
            @keyup="refreshSelectedFields('selected_custom_fields')"
            prepend-inner-icon="search"
          />
          <div class="pt-0">
          <v-list
            subheader
            two-line
            flat
          >
            <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
              <span class="white">  Selected ({{ filterItems(selected_custom_fields,true).length }})</span>
            </div>
            <v-list-item-group
              class="px-3 list-frame mt-3"
            >
            <v-form
                class="grid selected_custom_fields_grid"
              >
              <v-list-item
                v-for="selected_custom_field in filterItems(selected_custom_fields,true)"
                :key="selected_custom_field[0]"
                class="pa-0  single-list-item item"
                :ripple="false"
                :data-id="selected_custom_field[0]" 
              >
              <template v-slot:default="{ }">
                <v-list-item-action
                  class="mr-2 mt-n2"
                  @click="update_fields(selected_custom_field,false,false)"
                >
                  <v-icon color="#03B6FC">
                    mdi-checkbox-marked
                  </v-icon>
                </v-list-item-action>

                <v-list-item-content class="pa-1 justify-center">
                  <v-select
                    v-if="typeOfCustomFields[selected_custom_field[0]] === 'boolean'"
                    v-model="selected_custom_field[1]"
                    item-color="#AAA6A6"
                    outlined
                    :items="items"
                    item-text="text"
                    item-value="value"
                    :menu-props="{offsetY: true }"
                    :label="selected_custom_field[0]"
                    @change="updateFieldsValue(selected_custom_field,false)"
                    @click.stop
                    hide-details
                  />
                  <v-textarea
                    v-else-if="typeOfCustomFields[selected_custom_field[0]] === 'text'"
                    v-model="selected_custom_field[1]"
                    :label="selected_custom_field[0]"
                    outlined
                    hide-details
                    @change="updateFieldsValue(selected_custom_field,false)"
                  />
                  <div v-else-if="typeOfCustomFields[selected_custom_field[0]] === 'datetime'">

                     <v-text-field
                    v-model="selected_custom_field[1]"
                    :label="selected_custom_field[0]"
                    @click="openCustomField(selected_custom_field,$event)"
                    readonly
                    outlined
                    hide-details
                    ></v-text-field>
                  </div>
                  <v-text-field
                    v-else
                    v-model="selected_custom_field[1]"
                    :label="selected_custom_field[0]"
                    outlined
                    hide-details
                    @input="updateFieldsValue(selected_custom_field,false)"
                  />
                </v-list-item-content>
                <span v-if="dragEnabled" class="ml-2 mt-n5 handle" style="cursor:grab">
                  <v-icon class="mr-n2 ml-n2" color="grey">mdi-dots-vertical</v-icon>
                  <v-icon class="ml-n2" color="grey">mdi-dots-vertical</v-icon>
                </span>
                </template>
              </v-list-item>
            </v-form>
            </v-list-item-group>   
                        <datetime
                        ref="datetimepicker"
                        v-model="custom_field[1]"
                        class="theme-blue"
                        format="y-MM-dd HH:mm:ss ZZZ"
                        :placeholder="custom_field[0]"
                        type="datetime"
                        input-id="customStartDate"
                        :zone="timezone(custom_field[1])"
                        :value-zone="timezone(custom_field[1])"
                      >
                        <template slot="button-cancel">
                          Cancel
                        </template>
                        <template slot="button-confirm">
                          <span @click="updateFieldsValue(custom_field,false)"> Confirm</span>
                        </template>
                      </datetime>
          </v-list>
          <v-list
            subheader
            two-line
            flat
          >
            <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
              <span class="white">   Unselected ({{ filterItems(unselected_custom_fields,true).length }})</span>
            </div>
            <v-list-item-group class="px-4 list-frame mt-3">
              <v-list-item
                v-for="unselected_custom_field in filterItems(unselected_custom_fields,true)"
                :key="unselected_custom_field[0]"
                :ripple="false"
                class="pa-0"
              >
                <v-list-item-action
                  class="mr-2 mt-0"
                  @click="update_fields(unselected_custom_field,true,false)"
                >
                  <v-icon color="grey">
                    mdi-checkbox-blank-outline
                  </v-icon>
                </v-list-item-action>

                <v-list-item-content class="pa-1 justify-center">
                  <v-select
                    v-if="typeOfCustomFields[unselected_custom_field[0]] === 'boolean'"
                    v-model="unselected_custom_field[1]"
                    item-color="#AAA6A6"
                    outlined
                    :items="items"
                    item-text="text"
                    item-value="value"
                    :menu-props="{offsetY: true }"
                    :label="unselected_custom_field[0]"
                    @change="updateFieldsValue(unselected_custom_field,false)"
                    hide-details
                  />
                  <v-textarea
                    v-else-if="typeOfCustomFields[unselected_custom_field[0]] === 'text'"
                    v-model="unselected_custom_field[1]"
                    :label="unselected_custom_field[0]"
                    outlined
                    @change="updateFieldsValue(unselected_custom_field,false)"
                    hide-details
                  />
                  <div v-else-if="typeOfCustomFields[unselected_custom_field[0]] === 'datetime'">
                    <fieldset
                      class="mb-6"
                      style="border:1px solid lightgrey;border-radius:3px"
                    >
                      <legend
                        v-if="unselected_custom_field[1]"
                        class="caption font-weight-regular grey--text mb-n2 ml-2 text--darken-2"
                      >
                        {{ unselected_custom_field[0] }}
                      </legend>
                      <datetime
                        v-model="unselected_custom_field[1]"
                        class="theme-blue datetime-field"
                        format="y-MM-dd HH:mm:ss ZZZ"
                        :placeholder="unselected_custom_field[0]"
                        type="datetime"
                        :input-id="'startDate'+unselected_custom_field[0]"
                        :zone="timezone(unselected_custom_field[1])"
                        :value-zone="timezone(unselected_custom_field[1])"
                      >
                        <template slot="button-cancel">
                          Cancel
                        </template>
                        <template slot="button-confirm">
                          <span @click="updateFieldsValue(unselected_custom_field,false)"> Confirm</span>
                        </template>
                      </datetime>
                    </fieldset>
                  </div>
                  <v-text-field
                    v-else
                    v-model="unselected_custom_field[1]"
                    :label="unselected_custom_field[0]"
                    outlined
                    @input="updateFieldsValue(unselected_custom_field,false)"
                    hide-details
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-list>
  </div>
</template>

<script>
  import Muuri from 'muuri'
  import { Datetime } from 'vue-datetime'
  import { $marketingContacts } from "@core/services"
  import moment from 'moment'

  export default {
    components: {
      datetime: Datetime,
    },
    data () {
      return {
        unselected_default_fields: [],
        unselected_custom_fields: [],
        selected_default_fields: [],
        selected_custom_fields: [],
        updated_default_fields: {},
        updated_custom_fields: {},
        contactId: 1,
        loading: false,
        menuTime: false,
        searchString: '',
        searchStringCustom: '',
        typeOfCustomFields: {},
        menu: false,
        typeOfDefaultFields: {
          first_name: 'string', // all default types are static
          last_name: 'string',
          email: 'string',
          phone: 'string',
          fax: 'string',
        },
        workflowDisable: false,
        items: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
        grid: null,
        dragEnabled: true,
        selectedTab: 'selected_default_fields',
        custom_field:[],
      }
    },
    mounted () {
      this.fetch_customer_info()
    },
    methods: {
      refreshSelectedFields(tab, timeoutInterval = 0) {
        this.selectedTab = tab;
        if(this.grid) {
          this.grid.destroy();
        }
        this.setupSelectedFieldsGrid(timeoutInterval);
      },
      setupSelectedFieldsGrid(timeoutInterval = 0) {

        setTimeout(() => {
          this.dragEnabled = true;
          let searchString = this.selectedTab == 'selected_default_fields' ? this.searchString : this.searchStringCustom;
          if(searchString.toString().length > 0) {
            this.dragEnabled = false;
          }

          let selectedGrid = '.' + this.selectedTab + '_grid';
          
          this.grid = new Muuri(selectedGrid, {
            dragEnabled: this.dragEnabled,
          })
          
          this.grid.on('move', data => {
            let itemsData = [];
            let selectedTabData = Object.fromEntries([...this[this.selectedTab]])
            this.grid.getItems().forEach((item, index) => {
              itemsData.push([item.getElement().getAttribute('data-id'), selectedTabData[item.getElement().getAttribute('data-id')]])
            })
            this[this.selectedTab] = itemsData;
          })
        }, timeoutInterval)
      },
      updateFieldsValue (field, isDefault) {
        // async for calendar
        setTimeout(() => {
          if (isDefault) { this.updated_default_fields[field[0]] = field[1] } else {
            this.updated_custom_fields[field[0]] = field[1]
          }
        }, 100)
      },
      timezone (datetime) {
        return 'America/' + (moment().utcOffset(datetime)._offset === -300 ? 'Toronto' : 'Manaus') // Quick fix for converting to DST
      },
      filterItems (presets, custom) {
        return presets.filter(preset => {
          let regex = ''
          if (!custom) { regex = new RegExp('(' + this.searchString + ')', 'i') } else {
            regex = new RegExp('(' + this.searchStringCustom + ')', 'i')
          }
          return preset[0].match(regex)
        })
      },
      fetch_customer_info () {
        this.loading = true
        $marketingContacts.getFieldsData(this.$route.params.contactId).then(response => {
          const fieldsObj = response.data.data
          delete fieldsObj.contact.relation_table
          this.typeOfCustomFields = fieldsObj.fields_type
          Object.entries(fieldsObj.contact).forEach((element) => {
            if (element[0] !== 'created_at') { // can't be altered
              if (element[0] !== 'custom_fields') { // default fields
                this.unselected_default_fields.push([element[0], element[1]])
              } else {
                Object.entries(element[1]).forEach((customElement) => { // iterate custom fields
                  this.unselected_custom_fields.push([customElement[0], customElement[1]])
                })
              }
            }
          })
          if (fieldsObj.selected_fields) { // bifuricate selected unselected
            JSON.parse(fieldsObj.selected_fields).forEach((selectedElement) => {
              let indexSelectedDefault = null; let indexSelectedCustom = null
              indexSelectedDefault = Object.keys(Object.fromEntries(this.unselected_default_fields)).indexOf(selectedElement)
              if (indexSelectedDefault >= 0) {
                this.selected_default_fields.push(this.unselected_default_fields[indexSelectedDefault])
                this.unselected_default_fields.splice(indexSelectedDefault, 1)
              }
              indexSelectedCustom = Object.keys(Object.fromEntries(this.unselected_custom_fields)).indexOf(selectedElement)
              if (indexSelectedCustom >= 0) {
                this.selected_custom_fields.push(this.unselected_custom_fields[indexSelectedCustom])
                this.unselected_custom_fields.splice(indexSelectedCustom, 1)
              }
            })
          }
          this.setupSelectedFieldsGrid();
        }).catch(error => {

        }).finally(() => {
          this.loading = false
        })
      },
      update_fields (field, add, defaultField) {
        let index
        if (defaultField) {
          if (add) {
            index = this.unselected_default_fields.findIndex(x => x[0] === field[0])
            this.selected_default_fields.push(...this.unselected_default_fields.splice(index, 1))
          } else {
            index = this.selected_default_fields.findIndex(x => x[0] === field[0])
            this.unselected_default_fields.unshift(...this.selected_default_fields.splice(index, 1))
          }
        } else {
          if (add) {
            index = this.unselected_custom_fields.findIndex(x => x[0] === field[0])
            this.selected_custom_fields.push(...this.unselected_custom_fields.splice(index, 1))
          } else {
            index = this.selected_custom_fields.findIndex(x => x[0] === field[0])
            this.unselected_custom_fields.unshift(...this.selected_custom_fields.splice(index, 1))
          }
        }
        this.refreshSelectedFields(this.selectedTab);
      },
      save_fields () {
        this.loading = true
        const selected_fields = Object.fromEntries([...this.selected_custom_fields, ...this.selected_default_fields])
        const data = {
          workflow_disable: this.workflowDisable,
          selected_fields: JSON.stringify(Object.keys(selected_fields)),
          updated_fields: {
            default: this.updated_default_fields,
            custom: this.updated_custom_fields,
          },
        }
        $marketingContacts.setFields(this.$route.params.contactId, data).then(response => {
          let successMsg = response.data.message ? response.data.message : 
          'Contact was successfully updated';
          this.$store.commit('ui/snackbar', { message: successMsg, type: 'success' })
          this.$store.commit('ui/drawer.right', {
            show: false,
            component: null,
            response: { checkUpdateInfo: true },
          })
        }).catch(error => {

        }).finally(() => {
          this.loading = false
        })
      },
      openCustomField(data,event){
        this.custom_field=data;
        this.$refs.datetimepicker.open(event)
      },
    },
  }
</script>
<style lang = "scss">
#customStartDate {
    display: none;
}
</style>
<style lang = "scss" scoped>
.contact-info-wrapper .theme--light.v-tabs-items{
z-index: 0;
}
.theme-blue .vdatetime-popup__header,
.theme-blue .vdatetime-calendar__month__day--selected > span > span,
.theme-blue .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #03B6FC;
}

.theme-blue .vdatetime-year-picker__item--selected,
.theme-blue .vdatetime-time-picker__item--selected,
.theme-blue .vdatetime-popup__actions__button {
  color: #03B6FC;
}
.theme-blue>input{
    height: 50px;
    width: 100%;
    padding: 5px 10px;
}
.contact-info-wrapper .v-tab{
  color: #424242 !important;
  &--active{
    color:#03B6FC!important;
  }
}
.grid {
  position: relative;
}
.item {
  display: flex !important;
  /* overflow: hidden; */
  position: absolute;
  width: 100%;
  margin: 5px;
  z-index: 1;
}
.grid .item > div > div {
  height:auto !important;
}
.item.muuri-item-dragging {
  z-index: 3;
  background-color: #E5E5E5 !important;
}
.item.muuri-item-releasing {
  z-index: 2;
  background-color: #E5E5E5 !important;
}
.item.muuri-item-hidden {
  z-index: 0;
}
.v-list-item__content{
  min-height: 90px;
  height: 100%;
}
.datetime-field{
  height: 56px;
  padding: 18px 12px;
}
</style>
